import { useEffect } from "react";
import CookieConsentBanner from "react-cookie-consent";
import { trackEvent } from "@/lib/analytics";

export const CookieConsent = () => {
  const handleAccept = () => {
    // Enable analytics tracking
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
    
    trackEvent('cookie_consent', {
      category: 'privacy',
      label: 'accepted',
    });
  };

  const handleDecline = () => {
    // Disable analytics tracking
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    
    trackEvent('cookie_consent', {
      category: 'privacy',
      label: 'declined',
    });
  };

  useEffect(() => {
    // Set default consent to denied until user chooses
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'default', {
        'analytics_storage': 'denied',
        'wait_for_update': 500
      });
    }
  }, []);

  return (
    <CookieConsentBanner
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Decline"
      enableDeclineButton
      cookieName="ommni-cookie-consent"
      style={{
        background: "hsl(var(--background))",
        borderTop: "1px solid hsl(var(--border))",
        padding: "1rem 2rem",
        alignItems: "center",
        display: "flex",
        flexDirection: "row-reverse",
      }}
      buttonStyle={{
        background: "hsl(var(--primary))",
        color: "hsl(var(--primary-foreground))",
        fontSize: "14px",
        padding: "10px 24px",
        borderRadius: "6px",
        fontWeight: "500",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "hsl(var(--foreground))",
        fontSize: "14px",
        padding: "10px 24px",
        borderRadius: "6px",
        border: "1px solid hsl(var(--border))",
        fontWeight: "500",
      }}
      containerClasses="cookie-consent-container"
      contentClasses="cookie-consent-content"
      expires={365}
      onAccept={handleAccept}
      onDecline={handleDecline}
    >
      <span style={{ color: "hsl(var(--foreground))", fontSize: "14px" }}>
        We use cookies to enhance your experience, analyze site traffic, and provide personalized content. 
        By clicking "Accept All", you consent to our use of cookies.{" "}
        <a 
          href="/privacy" 
          style={{ 
            color: "hsl(var(--primary))", 
            textDecoration: "underline" 
          }}
        >
          Learn more
        </a>
      </span>
    </CookieConsentBanner>
  );
};
